const NS = 'MarketSummaryBlock';
const CLS = 'marketSummaryBlock';

export class MarketSummaryBlock {
	constructor(element) {
		this.element = element;
		this.$element = $(element);

		this.api = this.$element.attr('data-api');
		this.$marketSummaryMonthlyBlock = this.$element.find(`.marketSummaryMonthlyBlock`);
		this.$marketSummaryChartBlock = this.$element.find(`.marketSummaryChartBlock`);

		if(this.api) {
			$.ajax({
				type: 'GET',
				url: this.api,
				dataType: 'json',
				success: (response) => {
					if(response) {
						let chart = response.chart;
						let monthMicrons = response.monthMicrons;

						this.$marketSummaryMonthlyBlock.trigger('marketSummaryMonthlyBlock.update', {
							monthMicrons: monthMicrons
						});

						this.$marketSummaryChartBlock.trigger('marketSummaryChartBlock.update', {
							data: chart
						});
					}
				},
				error: () => {
					this.$marketSummaryMonthlyBlock.trigger('marketSummaryMonthlyBlock.update', {
						monthMicrons: null
					});

					this.$marketSummaryChartBlock.trigger('marketSummaryChartBlock.update', {
						data: null
					});
				}
			});
		}
	}
}
